export const PRODUCT_STATUS_OPTIONS = [
  { value: 'requested', label: 'Solicitado' },
  { value: 'trial', label: 'Teste grátis' },
  { value: 'installed', label: 'Instalado' },
  { value: 'expired', label: 'Expirado' },
  { value: 'canceled', label: 'Cancelado' }
]

export const ACTIVE_STATUSES = ['trial', 'installed']

export const TRIAL_DAYS = 7

export const TRACKED_FIELDS = ['status', 'active', 'expiration_at', 'subscription_at', 'canceled_at', 'trial_at']

export const DRIVER_INDICATION = 'driver-indication'
export const CM_FROTAS = 'cm-frotas'

export const DEPENDS_ON_FROTAS = 'A Indicação de Condutores depende do CaçaMultas Frotas. ' +
  'Libere o teste ou contrate o Frotas nesta conta antes.'

export const FROTAS_IN_USE = 'Não é possível desativar o CaçaMultas Frotas enquanto a Indicação de ' +
  'Condutores estiver ativa. Cancele a Indicação de Condutores primeiro.'

const ACTION_BY_STATUS = {
  trial: 'start_trial',
  installed: 'install',
  canceled: 'cancel',
  expired: 'expire'
}

export function statusLabel(status) {
  const option = PRODUCT_STATUS_OPTIONS.find(item => item.value === status)
  return option ? option.label : (status || 'não contratado')
}

export function isActive(status) {
  return ACTIVE_STATUSES.includes(status)
}

export function trialExpiration() {
  const date = new Date()
  date.setDate(date.getDate() + TRIAL_DAYS)
  return date.toISOString().substring(0, 10)
}

export function dateOnly(value) {
  return value ? String(value).substring(0, 10) : null
}

export function productActionFor(previous, next, options = {}) {
  const from = previous || ''
  const to = next || ''

  if (!to)
    return null

  if (from === to)
    return to === 'trial' && options.expirationChanged ? 'extend_trial' : null

  return ACTION_BY_STATUS[to] || null
}

function sameField(accountApp, original, field) {
  if (field === 'expiration_at')
    return dateOnly(accountApp[field]) === dateOnly(original[field])

  return accountApp[field] === original[field]
}

export function productChanged(accountApp, original) {
  if (!accountApp)
    return false

  if (!original)
    return true

  return !TRACKED_FIELDS.every(field => sameField(accountApp, original, field))
}

export function restoreProductFields(accountApp, original) {
  TRACKED_FIELDS.forEach(field => { accountApp[field] = original[field] })

  return accountApp
}

export function pendingProductChanges(accountApps, pristineApps) {
  return (accountApps || []).reduce((changes, accountApp) => {
    const original = (pristineApps || []).find(item => item.app_id === accountApp.app_id)
    const previous = original ? original.status : ''
    const expirationChanged = dateOnly(accountApp.expiration_at) !== dateOnly(original && original.expiration_at)
    const action = productActionFor(previous, accountApp.status, { expirationChanged: expirationChanged })

    if (action)
      changes.push({ app_id: accountApp.app_id, action: action, expiration_at: dateOnly(accountApp.expiration_at) })

    return changes
  }, [])
}

export function hasActiveProduct(accountApps, name) {
  return (accountApps || []).some(item => item.name === name && item.active)
}

export function dependencyError(appName, status, activeNames) {
  const active = activeNames || []

  if (appName === DRIVER_INDICATION && isActive(status) && !active.includes(CM_FROTAS))
    return DEPENDS_ON_FROTAS

  if (appName === CM_FROTAS && !isActive(status) && active.includes(DRIVER_INDICATION))
    return FROTAS_IN_USE

  return null
}
